/* eslint-disable react/no-unescaped-entities */
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Seo, { ldBreadcrumb } from "@/components/Seo";
import {
  MentionsContent, CGUContent, CGVContent,
  PrivacyContent, CookiesContent, CharteContent,
  RolePlateformeContent, MiseEnRelationContent,
  CharteExpertContent, CharteUtilisateurContent,
  DefinitionsContent,
} from "@/content/legal.jsx";

const TABS = [
  { id: "role", label: "Rôle de CONFILEX", Content: RolePlateformeContent },
  { id: "definitions", label: "Définitions", Content: DefinitionsContent },
  { id: "mise-en-relation", label: "Mise en relation", Content: MiseEnRelationContent },
  { id: "mentions", label: "Mentions légales", Content: MentionsContent },
  { id: "cgu", label: "CGU", Content: CGUContent },
  { id: "cgv", label: "CGV", Content: CGVContent },
  { id: "privacy", label: "Confidentialité", Content: PrivacyContent },
  { id: "cookies", label: "Cookies", Content: CookiesContent },
  { id: "charte-expert", label: "Charte spécialiste", Content: CharteExpertContent },
  { id: "charte-utilisateur", label: "Charte utilisateur", Content: CharteUtilisateurContent },
  { id: "charte", label: "Charte qualité", Content: CharteContent },
];

export default function Legal() {
  return (
    <div className="bg-[#FAFAF7] min-h-screen">
      <Seo
        title="Mentions légales, CGU, CGV, confidentialité, cookies, charte qualité"
        description="Cadre contractuel CONFILEX : mentions légales, CGU, CGV, politique de confidentialité (RGPD), cookies, charte qualité du réseau. Conformité française complète."
        canonical="/legal"
        keywords={["mentions légales confilex", "CGU CGV", "RGPD confilex", "politique confidentialité", "cookies"]}
        jsonLd={[
          ldBreadcrumb([{ name: "Accueil", url: "/" }, { name: "Informations légales", url: "/legal" }]),
        ]}
      />
      <Navbar variant="light" />
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-12">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C9A961] mb-3">Cadre contractuel</div>
        <h1 className="font-serif text-4xl text-[#0B3A2A] tracking-tight mb-10">Informations légales</h1>

        <Tabs defaultValue="role" className="space-y-6">
          <TabsList className="rounded-full p-1 bg-slate-100 flex-wrap h-auto" data-testid="legal-tabs">
            {TABS.map((t) => (
              <TabsTrigger key={t.id} value={t.id} className="rounded-full" data-testid={`legal-tab-${t.id}`}>
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>

          <div className="bg-white rounded-2xl border border-slate-100 p-8 lg:p-10">
            {TABS.map((t) => (
              <TabsContent key={t.id} value={t.id}>
                <t.Content />
              </TabsContent>
            ))}
          </div>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
}
